import React, { useState } from "react";
import MappedRules from "./MappedRules";
import ActiveFiles from "./ActiveFiles";
import { useSelector } from "react-redux";
import moment from "moment";
import { Box, Button } from "@mui/material";
import { useCategory } from "../components/IpProvider";



const Files = () => {
	const [activeTab, setActiveTab] = useState(1);


	const { switchCategory } = useCategory()

	const activeFiles = useSelector((state) => state.fileStore?.activeFiles);

	const successFIleCount = activeFiles ? activeFiles.filter((obj) => obj.status == "Pass").length : 0;



	return (
		<div>
			{/* Small tweaks to be responsive */}
			<Box sx={{
				display: "flex",
				flexDirection: { xs: "column", lg: "row" },
				gap: {
					xs: 2,
					lg: 0
				},
				justifyContent: "space-between", marginLeft: "20px", alignItems: "center"
			}}>
				<Box sx={{ display: "flex", gap: 1 }}>
					<Button size="medium" variant={activeTab == 1 ? "contained" : "outlined"} sx={{ mx: 1 }} onClick={() => setActiveTab(1)}>
						Files
					</Button>
					<Button size="medium" sx={{
						fontSize: "16px",
					}} variant={activeTab == 2 ? "contained" : "outlined"} onClick={() => {
						switchCategory("patent")
						setActiveTab(2)
					}}>
						Mapped Rules Patent
					</Button>
					<Button size="medium"
						sx={{
							fontSize: "16px",
						}}
						variant={activeTab == 3 ? "contained" : "outlined"} onClick={() => {
							switchCategory("trademark")
							setActiveTab(3)
						}}>
						Mapped Rules Trademarks
					</Button>
				</Box>

				{activeTab == 1 ? (
					<Box sx={{
						display: "flex", flexDirection: "column", justifyContent: "flex-end",
						textAlign: {
							xs: "center",
							lg: "right"
						}
					}}>
						<p style={{ margin: "0px" }}>Upload Date: {activeFiles?.[0]?.uploadedon? moment(activeFiles?.[0]?.uploadedon).format("MMM DD, YYYY"): "-"}</p>
						<p style={{ margin: "0px" }}>({successFIleCount} files uploaded succesfully, Encountered issues are as below)</p>
					</Box>
				) : null}
			</Box>


			<Box sx={{ m: 4 }} className="file-content">
				{activeTab == 1 ? <ActiveFiles /> : null}
				{activeTab == 2 || activeTab == 3 ? <MappedRules setActiveTab={setActiveTab} /> : null}
			</Box>
		</div>
	);
};

export default Files;